import ForgotPwd from '@/service/forgot-password'

export default {
  name: 'forgot-password',
  components: {},
  props: [],
  data () {
    return {
      data: {
        email:""
      },
      errors:"",
      btn_submit: false
    }
  },
  computed: {
    
  },
  mounted () {

  },
  methods: {
    login (){
      this.$router.replace('/login')
    },
    resetPassword(){
      this.btn_submit = true
      ForgotPwd.forgotPwd(this.data).then(res=>{
        if(res.status === 200){
          this.$router.replace({name:'login', params: {content:"You will receive a password recovery link at your email address in a few minutes."}})
        }
      }).catch(err => {
        this.btn_submit = false
        this.errors = err.data.errors
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/forgot-password/forgot-password.js